import { render, staticRenderFns } from "./show.vue?vue&type=template&id=7b70a3cc&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b70a3cc')) {
      api.createRecord('7b70a3cc', component.options)
    } else {
      api.reload('7b70a3cc', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=7b70a3cc&", function () {
      api.rerender('7b70a3cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/information/show.vue"
export default component.exports